import React, { useEffect, useState } from "react";
import { FxmsData } from "../datas/FxData";
import { FxDataEdit } from "./FxDataEdit";
import { FxDataPopup } from "./FxDataPopup";
import { FxUiData } from "../datas/FxUiData";
import { FxCrud } from "./../components/grid/FxCrud";
import { FxDataGridAuto } from "./../components/grid/FxDataGrid";
import { GadgetDashboard } from "../components/GadgetDashboard";
import { OpClass } from "./../datas/OpClass";

/**
 * 특정 자원.
 * 개발자 : 김종훈.
 * 개발년월 : 2022.11.
 * @param { opObj, selectedData, selectedDataId } props
 * @returns
 */
export const FxResource = (props) => {
  const { selectedData, selectedDataId, resourceRef, attr ,refershGridData} = props;
  const opObj = props.opObj
    ? props.opObj
    : props.menu
    ? props.menu
    : FxmsData.getOpObj(props.opId);

  console.log("*** FxResource ***   selectedData, props, opObj", selectedData, props, opObj);

  useEffect(() => {
    // close버튼이고 창닫기함수가 있으면 클릭했을때 창닫기함수가 호출되도록 한다.
    if (opObj) {
      const opClass = OpClass.getOpClass(opObj.opId);
      if (props.onCloseBtnClick) {
        const attrClass = opClass.getCloseButtonAttrClass();
        if (attrClass) {
          attrClass.setOnClick(props.onCloseBtnClick);
        }
      }
    }
  }, []);


  if (opObj) {

    // 2023.03.10 : subkjh
    // 해당 기능에 지정된 화면이 있으면 해당 화면을 사용한다.
    const opUi = FxUiData.getCompResource(opObj.opId);
    if ( opUi ) {
      return <FxUiData.makeResource opId={opObj.opId} attr={attr} menuFullName={opObj.menuFullName} name={opObj.opId} selectedData={selectedData} selectedDataId={selectedDataId} onCloseBtnClick={props.onCloseBtnClick} refershGridData={refershGridData}/>;
    }

    if(opObj.uiCmptName === "LINK") {

      return (<GadgetDashboard dashbNo={opObj.opUri} editable={false} />)

    } else if (opObj.uiCmptName === "CRUD") {

      return <FxCrud menu={opObj} />;

    } else if (opObj.uiCmptName === "CRUD-EDIT") {

      return (
        <FxDataEdit
          attr={attr}
          opId={opObj.opId}
          selectedData={selectedData}
          selectedDataId={selectedDataId}
          isPopupCrud={true}
          refershGridData={refershGridData}
          ref={resourceRef}
        />
      );
    } else if (opObj.uiCmptName === "CRUD-CREATE") {
      return (
        <FxDataEdit
          attr={attr}
          opId={opObj.opId}
          selectedData={selectedData}
          selectedDataId={selectedDataId}
          isPopupCrud={true}
          refershGridData={refershGridData}
        />
      );
    } else if (opObj.uiCmptName === "CRUD-SHOW") {
      return (
        <FxDataEdit
          opId={opObj.opId}
          selectedData={selectedData}
          selectedDataId={selectedDataId}
          isPopupCrud={true}
        />
      );
    } else if (opObj.uiCmptName === "CRUD-LIST-AUTO") {
      return (
        <FxDataGridAuto
          menu={opObj}
          paraData={selectedData}
          paraId={selectedDataId}
        />
      );
    } else if(opObj.uiCmptName === "CRUD_POPUP"){
      return (
        <FxDataPopup
          opId={opObj.opId}
          selectedData={selectedData}
          isPopupCrud={true}
        />
      );
    } else {
      return <FxUiData.makeResource uiCmptName={opObj.uiCmptName} opId={opObj.opId} name={opObj.opId} selectedData={selectedData} selectedDataId={selectedDataId}/>;
    }
  } else {
    console.log(
      "*** ERROR ************************************************************************"
    );
    console.log("*  opId = " + props.opId);
    console.log("*  not defined");
    console.log(
      "**********************************************************************************"
    );
    return (
      <div className="FxErrMsg">
        <span>{props.opId} 화면 정보를 알 수 없습니다.</span>
      </div>
    );
  }
};
